import { ofType } from 'redux-observable';
import { of } from 'rxjs/observable/of';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';
import { concat } from 'rxjs/observable/concat';

import { forkEpic } from '../../utils/epics/forkEpic';
import getAreasEpic from '../areas/getAreas';
import getOrgUserRoleEpic from './getOrgUserRole';

import {
  types as actions,
  setSitesAction,
  getAreasAction,
  setCurrentSiteAction,
  getOrgUserRole
} from '../../reducers/actions';
import { OrganizationsService } from '../../services';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.GET_ORG_SITES),
    switchMap(action => 
      OrganizationsService.getOrgSites(store, action.orgId).pipe(
        switchMap(data => {
          let { loadChildren, loadAreaChildren } = action;
          let currentSiteId = localStorage.getItem(`airfinder_selected_site`);
            // sets currently selected site to store.site
          let currentSite = data.find(site => site.id === currentSiteId) || data[0];
          if(action.orgId){
            const getOrgUserRoleAndSetSite$ = concat(
              forkEpic(getOrgUserRoleEpic,store,getOrgUserRole(action.orgId)),
              of(setSitesAction(data, loadChildren))
            );
            if (currentSite) {
              return concat(
                getOrgUserRoleAndSetSite$,
                of(setCurrentSiteAction(currentSite, true)),
                forkEpic(getAreasEpic,store,getAreasAction(currentSite.id, loadAreaChildren, undefined, true))
              )
            } else {
              return getOrgUserRoleAndSetSite$;
            }
          }else{
            return of(setSitesAction(data)); //TODO add the call for site roles for user
          }
        }),
        catchError(retryAuthentication(action$, 'epics/organizations/getOrgSites'))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/organizations/getOrgSites.js